export enum ProductTypeForSearchFilterEnum {
  assortmentProduct = 'assortmentProduct',
  buyingSessionProduct = 'buyingSessionProduct',
  orderProduct = 'orderProduct'
}
